module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAAd0SU1FB94LGwsWKDFQxLwAAAAiSURBVDjLY2AYBaOAUsCopKT0n5YWMNHaB0PfglEwCigHAGA/AW2PxVkiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_en_servicio.png
// module id = Thf6
// module chunks = 0